module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/2_baiyi_pc.f26d0fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/uploads/2_baiyi_pc.jpg
// module id = S+BV
// module chunks = 3 4